import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Alert,
  CircularProgress,
  IconButton,
  List,
  ListItemIcon,
  Menu,
  MenuItem,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showInsufficientCreditsModal } from "../../../actions/creditActions";
import { deductCredits } from "../../../utils/HelperFunction/deductCredits";
import { CMSContext } from "../context/CaseManagmentContext";
import { Delete } from "@mui/icons-material";
import { blue, red } from "@mui/material/colors";
import ConfirmationDialog from "../../../dialogs/ConfirmationDialog";
import { toast } from "react-toastify";
import { searchSections } from "../../../actions/statuteSearchActions";
import StatuteDetailDialog from "../../../dialogs/StatuteDetailDialog";
import { deleteStatuteReferenceApi } from "../../../services/api/caseManagementApi";
const formatCaseTitle = (title) => {
  if (!title) return;
  const splitTitle = title?.split("Honorable")[0];
  const titleCaseTitle = splitTitle
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
  return titleCaseTitle;
};
export const StatuteReferenceTable = () => {
  const [openPreview, setOpenPreview] = useState(false);
  const [selectItem, setSelectItem] = useState([]);
  const [refSelectedStatute, setRefSelectedStatute] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState(null);
  const dispatch = useDispatch();
  const [refCaseToDelete, setRefCaseToDelete] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const credits = useSelector((state) => state.credit.credits);
  const userId = useSelector((state) => state.credit.userId);
  const { fetchingRefStatute, refStatute, selectedCase, setRefStatute } =
    useContext(CMSContext);

  const [loading, setLoading] = useState(false);

  const handlePreviewClick = (item) => {
    let creditsToDeduct = 1;
    if (credits <= 0 || credits <= creditsToDeduct) {
      dispatch(showInsufficientCreditsModal()); // Trigger modal if credits are insufficient
      return;
    }
    setRefSelectedStatute(item);
    const cleanedName =
      item.Act_Ordinance?.replace(/<\/?[^>]+(>|$)/g, "") ??
      item.Statute_Name?.replace(/<\/?[^>]+(>|$)/g, "") ??
      "";
    dispatch(searchSections("", cleanedName, "Title"));
    setOpenPreview(true);

    const deductionSuccess = deductCredits(
      { userId, creditsToDeduct: 1, event: "Preview Bookmarked Document" },
      dispatch,
    );

    if (!deductionSuccess) {
      console.warn(
        "Failed to deduct credits. Ensure retry or user notification.",
      );
    }
  };

  const handleDelete = async () => {
    if (!refCaseToDelete || !selectedCase) return;

    let creditsToDeduct = 1;
    if (credits <= 0 || credits < creditsToDeduct) {
      dispatch(showInsufficientCreditsModal());
      return;
    }
    const bookmarkId = refCaseToDelete?.related_data?.find(
      (ref) => selectedCase?.statuteReferences?.includes(ref.Bookmark_ID)
    )?.Bookmark_ID;
    try {
      setLoading(true);
      const response = await deleteStatuteReferenceApi(
        selectedCase._id,
        bookmarkId,
      );

      if (response.status < 200 || response.status >= 300) {
        toast.error("Failed to delete the reference statute");
        throw new Error("Failed to delete the reference statute");
      }

      setRefStatute((prevStatutes) =>
        prevStatutes.filter(
          (obj) => !obj.related_data?.some((ref) => ref.Bookmark_ID === bookmarkId)
        ),
      );

      toast.success("Reference statute deleted successfully.");
      setDeleteModal(false);
      setRefCaseToDelete(null);

      // Deduct credits
      const deductionSuccess = deductCredits(
        {
          userId,
          creditsToDeduct: 1,
          event: "Deleted reference statute.",
        },
        dispatch,
      );

      if (!deductionSuccess) {
        console.warn(
          "Failed to deduct credits. Ensure retry or user notification.",
        );
      }
    } catch (error) {
      console.error("Error deleting reference statute:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
    setRefSelectedStatute(null);
  };

  const getSortedCitations = (citations) => {
    const extractYear = (text) => {
      const match = text?.match(/\b(19|20)\d{2}\b/);
      return match ? parseInt(match[0], 10) : -Infinity;
    };

    const formattedItems = (citations || []).flat(1).map((item) => {
      try {
        const parsedItem = JSON.parse(item);
        let citation = parsedItem?.Citation_Name || item;
        return citation.replace("Bookmark this Case", "").trim();
      } catch (error) {
        return item;
      }
    });

    return [...formattedItems].sort((a, b) => extractYear(a) - extractYear(b));
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 1,
        }}
      >
        <Typography
          sx={{ fontSize: "18px", fontWeight: "bold", color: "#003D78" }}
        >
          Reference Statute
        </Typography>
      </Box>
      <TableContainer
        sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
        component={Paper}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#003D78", color: "#FFFFFF" }}>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>Title</Box>
              </TableCell>
              
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Year
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Category
              </TableCell>

              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Reference Statute
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "600",
                  fontSize: "13px",
                  color: "#FFFFFF",
                  py: "6px",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fetchingRefStatute ? (
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{
                    textAlign: "center",
                    padding: "16px",
                    fontSize: "14px",
                    color: "#777",
                  }}
                >
                  <CircularProgress size={18} sx={{ color: "#003D78" }} />
                </TableCell>
              </TableRow>
            ) : Array.isArray(refStatute) && refStatute.length > 0 ? (
              refStatute.map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                    onClick={() => handlePreviewClick(item)}
                  >
                    {formatCaseTitle(item.Statute_Name)}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    {item?.Year}
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      fontSize: "13px",
                    }}
                  >
                    Statute
                  </TableCell>

                  <TableCell
                    sx={{
                      maxWidth: 400,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      py: 1,
                      cursor: "pointer",
                      fontSize: "13px",
                    }}
                  >
                    <Stack spacing={0.5}>
                      {item?.Citations?.length > 0 && (
                        <List
                          component="div"
                          disablePadding
                          sx={{
                            maxHeight: "24rem",
                            overflowY: "auto",
                            scrollBehavior: "smooth",
                            "::-webkit-scrollbar": { width: "5px" },
                            "::-webkit-scrollbar-track": { background: "#fff" },
                            "::-webkit-scrollbar-thumb": {
                              background: "#bbb",
                              borderRadius: "6px",
                            },
                          }}
                        >
                          {getSortedCitations(item.Citations).map(
                            (citation, index) => (
                              <Box
                                key={index}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",

                                  marginX: "16px",
                                  paddingY: "4px",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: { xs: "11px", md: "12px" },
                                    flexGrow: 1,
                                  }}
                                >
                                  {`${index + 1}- ${citation}`}
                                </Typography>
                              </Box>
                            ),
                          )}
                        </List>
                      )}
                    </Stack>
                  </TableCell>
                  <TableCell sx={{ py: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        size="small"
                        sx={{
                          color: "inherit",
                          "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                          },
                        }}
                        onClick={(event) => {
                          setSelectItem(item);
                          setAnchorEl(event.currentTarget);
                        }}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          sx: {
                            //mt: 3.5,
                            boxShadow:
                              "0px 4px 12px rgba(0, 0, 0, 0.1) !important",
                            borderRadius: "8px",
                            //zIndex: 1,
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            handlePreviewClick(selectItem);
                            setAnchorEl(null);
                          }}
                        >
                          <ListItemIcon>
                            <VisibilityIcon
                              fontSize="small"
                              sx={{ color: blue[500] }}
                            />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "13px" }}>
                            Preview
                          </Typography>
                        </MenuItem>

                        <MenuItem
                          onClick={() => {
                            setRefCaseToDelete(selectItem);
                            setDeleteModal(true);
                            setAnchorEl(null);
                          }}
                        >
                          <ListItemIcon>
                            <Delete fontSize="small" sx={{ color: red[500] }} />
                          </ListItemIcon>
                          <Typography sx={{ fontSize: "13px" }}>
                            Delete
                          </Typography>
                        </MenuItem>
                      </Menu>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={12}
                  sx={{
                    textAlign: "center",
                    padding: "16px",
                    fontSize: "14px",
                    color: "#777",
                  }}
                >
                  No Reference Statute Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {refSelectedStatute && (
        <StatuteDetailDialog open={openPreview} onClose={handleClosePreview} />
      )}
      {snackbarMessage && (
        <Snackbar
          open={!!snackbarMessage}
          autoHideDuration={6000}
          onClose={() => setSnackbarMessage(null)}
        >
          <Alert
            onClose={() => setSnackbarMessage(null)}
            severity={snackbarMessage.type}
            sx={{ width: "100%" }}
          >
            {snackbarMessage.text}
          </Alert>
        </Snackbar>
      )}
      {/* Confirmation Dialog */}
      <ConfirmationDialog
        open={deleteModal}
        onClose={() => {
          setRefCaseToDelete(null);
          setDeleteModal(false);
        }}
        onConfirm={() => {
          if (deleteModal) {
            handleDelete(refCaseToDelete?.Bookmark_ID);
          }
        }}
        title="Confirm Delete"
        contentText={`Are you sure you want to delete the reference case "${formatCaseTitle(
          refCaseToDelete?.Statute_Name,
        )}"? This action cannot be undone.`}
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        loading={loading}
      />
    </Box>
  );
};
